require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-instructor-spotlight-sam-hamm-and-the-transition-from-higher-education-to-teaching-at-code-fellows-part-2.json") })
        }
      }, "path---blog-instructor-spotlight-sam-hamm-and-the-transition-from-higher-education-to-teaching-at-code-fellows-part-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-instructor-spotlight-sam-hamm-and-the-transition-from-higher-education-to-teaching-at-code-fellows-part-2!./.cache/json/blog-instructor-spotlight-sam-hamm-and-the-transition-from-higher-education-to-teaching-at-code-fellows-part-2.json
// module id = 884
// module chunks = 231608221292675